/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Option_Edit_RequiredInputs */



/**
* | output |
* | --- |
* | "Edit Required" |
*
* @param {Work_Order_Publish_Option_Edit_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_option_edit_required = /** @type {((inputs?: Work_Order_Publish_Option_Edit_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Option_Edit_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modification requise")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeitung erforderlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica richiesta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Требуется редактирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Edición requerida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("需要编辑")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集が必要です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादन आवश्यक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("É necessário editar.")
	return /** @type {LocalizedString} */ ("Edit Required")
});